// extracted by mini-css-extract-plugin
export default {"uploadIcon":"InventoryCreateModal_uploadIcon__EzoFE","spinWrapper":"InventoryCreateModal_spinWrapper__ZoYSC","uploadText":"InventoryCreateModal_uploadText__aoOi4"};